import { Button } from 'odc-shared/components';

import IconMonetizationDocs from './IconMonetizationDocs';
import IconUserGrowthDocs from './IconUserGrowthDocs';

import './index.scss';

export enum DocType {
  Monetization = 'Monetization',
  UserGrowth = 'UserGrowth',
}
const docInfo = {
  [DocType.Monetization]: {
    title: 'Monetization',
    desc: 'Documentation for SDK integration, API reference',
    link: '/supportcenter/article?platform=publisher',
  },
  [DocType.UserGrowth]: {
    title: 'User growth',
    desc: 'Guides for campaign management, creative specs',
    link: 'supportcenter/article?platform=advertiser',
  },
};
type Props = {
  type: DocType;
}

const DocsCard = (props: Props) => {
  const { type } = props;
  const { title, desc, link } = docInfo[type];
  const onClick = () => {
    window.open(link, '_blank');
  };
  return (
    <div className="odc-docs-card" onClick={onClick}>
      <div className="odc-docs-card-content">
        <div className="odc-docs-card-title">{title}</div>
        <div className="odc-docs-card-desc">{desc}</div>
        <Button size="sm" type="primary">View docs</Button>
      </div>
      <div className="odc-docs-card-icon">
        {type === DocType.Monetization && <IconMonetizationDocs />}
        {type === DocType.UserGrowth && <IconUserGrowthDocs />}
      </div>
    </div>
  );
};

export default DocsCard;